<template>
  <div>
    <TableFilters
      :filters="['product', 'dateRange', 'warehouse']"
      v-model="filter"
      :columns="columns"
      @updateColumnsTable="updateColumnsTable"
      :export="[`purchaseexport`]"
    ></TableFilters>

    <v-row class="py-0 my-0">
      <v-col cols="12" md="12" lg="7" class="pa-5">
        <v-btn-toggle v-model="toggle_exclusive">
          <v-btn @click="viewpdfFile()"> View Report </v-btn>
          <v-btn @click="exportPDF()"> Generate PDF </v-btn>
          <v-btn @click="exceldownload()"> Generate CSV </v-btn>
        </v-btn-toggle>
      </v-col>
    </v-row>

    <v-card class="lighten-12 mt-2" v-show="false">
      <v-container fluid class="light gray lighten-12">
        <v-row>
          <v-card-text class="pa-0">
            <v-data-table
              :items-per-page="1000"
              :fixed-header="true"
              :headers="headers"
              :items="PurchaseList"
              class="row-pointer"
              id="indextable5"
            >
              <template v-slot:no-data>
                <div class="mt-16 container justify-center item-center">
                  <noData name="Purchase" />
                </div>
              </template>

              <template v-slot:top>
                <tr>
                  <th>Product Name:</th>
                  <th>{{ filterDatas.productquery }}</th>
                  <th></th>
                  <th>Warehouse Name:</th>
                  <th>{{ filterDatas.warehousequery }}</th>
                </tr>
              </template>

              <template v-slot:item.date="{ item }">{{
                item.purchase.date ? item.purchase.date : '.......'
              }}</template>
              <template v-slot:item.batch="{ item }">{{
                item.batch.batch ? item.batch.batch : '.......'
              }}</template>

              <template v-slot:item.quantity="{ item }">{{
                item.quantity ? item.quantity : '.......'
              }}</template>

              <template v-slot:item.total_amount="{ item }">{{
                item.purchase.total_amount
                  ? item.purchase.total_amount
                  : '.......'
              }}</template>

              <template v-slot:item.discount_amount="{ item }">{{
                item.purchase.discount_amount
                  ? item.purchase.discount_amount
                  : '.......'
              }}</template>

              <template v-slot:item.sub_total_amount="{ item }">{{
                item.purchase.sub_total_amount
                  ? item.purchase.sub_total_amount
                  : '.......'
              }}</template>

              <template v-slot:item.purchase_from="{ item }">{{
                item.purchase.purchase_from
                  ? item.purchase.purchase_from
                  : '.......'
              }}</template>

              <template v-slot:item.warehouse="{ item }">{{
                item.purchase.wareHouse.name
                  ? item.purchase.wareHouse.name
                  : '.......'
              }}</template>
            </v-data-table>
          </v-card-text>
        </v-row>
      </v-container>
    </v-card>
  </div>
</template>
<script>
import TableFilters from '@/components/base/TableFilters';
import noData from '@/components/shared/noItem';
import jsPDF from 'jspdf';

import autoTable from 'jspdf-autotable';
import XLSX from 'xlsx';
import { DateTime } from '@grapecity/wijmo';
import moment from 'moment';
import { mapState } from 'vuex';

import _ from 'lodash';
export default {
  data: () => ({
    messages: [],
    hide: '',
    status: [
      { text: 'Active', value: 'active' },
      { text: 'Archived', value: 'archived' },
    ],

    columns: [
      {
        text: 'No',
        value: 'no',
        show: true,
        disabled: false,
        width: '14%',
        render: (item) => item?.no,
      },
      {
        text: 'Date',
        value: 'date',
        show: true,
        disabled: false,
        width: '14%',
        render: (item) => moment(item?.purchase.date).format('DD-MM-YYYY'),
      },
      {
        text: 'Warehouse',
        value: 'warehouse',
        show: true,
        disabled: false,
        width: '16.5%',
        render: (item) => item?.purchase.wareHouse.name,
      },

      {
        text: 'Batch',
        value: 'batch',
        show: true,
        disabled: false,
        width: '16.5%',
        render: (item) => item?.batch.batch,
      },
      {
        text: 'Quantity',
        value: 'quantity',
        show: true,
        disabled: false,
        width: '16.5%',
        render: (item) => item?.quantity,
      },

      {
        text: 'Amount',
        value: 'total_amount',
        show: true,
        disabled: false,
        width: '16.5%',
        render: (item) => item?.purchase.total_amount,
      },

      {
        text: 'Discount Amount',
        value: 'discount_amount',
        show: true,
        disabled: false,
        width: '16.5%',
        render: (item) => item?.purchase.discount_amount,
      },

      {
        text: 'Total Amount',
        value: 'sub_total_amount',
        show: true,
        disabled: false,
        width: '16.5%',
        render: (item) => item?.purchase.sub_total_amount,
      },

      {
        text: 'Purchase From',
        value: 'purchase_from',
        show: true,
        disabled: false,
        width: '16.5%',
        render: (item) => item?.purchase.purchase_from,
      },
    ],
    PurchaseList: [],
    filter: {
      invoice_status: '',
      start: '',
      end: '',
      amount: '',
      supplier: '',
      search: '',
    },
    menu: false,
    total: 0,
    paid: 0,
    discount: 0,
  }),
  components: {
    TableFilters,
    noData,
  },
  computed: {
    ...mapState(['filterDatas']),

    headers: function () {
      return this.columns.filter((item) => item.show == true);
    },
  },
  created() {
    this.$store.commit('UPDATE_PDF_VISIBLE', false);
    this.$store.commit('UPDATE_PDFLOADNG_VISIBLE', false);
  },
  watch: {
    filter(value) {
      this.$store.commit('UPDATE_PDF_DATAS', null);
      this.$store.commit('UPDATE_PDF_VISIBLE', false);
    },
  },
  methods: {
    updateColumnsTable() {
      this.$store.commit('UPDATE_PDF_VISIBLE', false);
      this.$store.commit('UPDATE_PDFLOADNG_VISIBLE', true);
      setTimeout(() => {
        this.$store.commit('UPDATE_PDF_HEADERS', this.headers);
        this.$store.commit('UPDATE_PDF_VISIBLE', true);
        this.$store.commit('UPDATE_PDFLOADNG_VISIBLE', false);
      }, 100);
    },
    generateReport(callBack = () => {}) {
      if (this.filter.warehouse && this.filter.product) {
        this.$store.commit('UPDATE_PDF_VISIBLE', true);
        this.$store.commit('UPDATE_PDFLOADNG_VISIBLE', true);

        var filter = this.filter;
        this.$store
          .dispatch('report/getPurchaseReportProductManagement', filter)
          .then((res) => {
            if (res.data.data.length === 0) {
              this.PurchaseList = [];
            } else {
              this.PurchaseList = res.data.data[0].purchaseItems;
            }
            this.total = this.sumTotalField(
              this.PurchaseList,
              'purchase.total_amount',
            );
            this.paid = this.sumPaidField(
              this.PurchaseList,
              'purchase.paid_amount',
            );
            this.discount = this.sumDiscountField(
              this.PurchaseList,
              'purchase.discount_amount',
            );
            let i = 1;
            this.PurchaseList.map((p) => {
              p.no = i;
              i++;
            });
            var purchaseAmount = {
              total: this.total,
              paid: this.paid,
              discount: this.discount,
            };
            setTimeout(() => {
              // Update Pdf To List
              this.$store.commit('UPDATE_PDF_HEADERS', this.headers);
              // Update Pdf To List Datas
              this.$store.commit('UPDATE_PDF_DATAS', this.PurchaseList);
              // Update Pdf To List_Title
              this.$store.commit(
                'UPDATE_PDF_TITLE',
                'Purchase Report Product Management',
              );
              this.$store.commit('UPDATE_PDFLOADNG_VISIBLE', false);
              this.$store.commit('UPDATE_PURCHASE_TOTAL', purchaseAmount);

              callBack();
            }, 100);
          })

          .catch((err) => {
            this.isLoading = false;
            this.$store.commit('UPDATE_PDFLOADNG_VISIBLE', false);
            this.$store.commit('UPDATE_PDF_VISIBLE', false);

            this.messages = err.data.title;
          });
      } else if (this.filter.warehouse) {
        this.$confirm('Please Select the Product then Try?');
      } else if (this.filter.product) {
        this.$confirm('Please Select the Warehouse then Try?');
      } else {
        this.$confirm('Please Select the Warehouse and Product then Try?');
      }
    },
    async viewpdfFile() {
      await this.generateReport();
      setTimeout(() => {
        if (this.PurchaseList.length > 0) {
          this.$store.commit('UPDATE_PDF_VISIBLE', true);
          this.$store.commit('UPDATE_PDFLOADNG_VISIBLE', false);
        }
      }, 1000);
    },

    sumTotalField(array) {
      let value = 0;
      array.map((element) => {
        value += element.purchase.total_amount;
      });
      return value;
    },
    sumPaidField(array) {
      let value = 0;
      array.map((element) => {
        value += element.purchase.paid_amount;
      });
      return value;
    },
    sumDiscountField(array) {
      let value = 0;
      array.map((element) => {
        value += element.purchase.discount_amount;
      });
      return value;
    },
    //Product Details Export Pdf
    async exportPDF() {
      const printPdf = () => {
        let Data = _.cloneDeep(this.PurchaseList);
        for (let x = 0; x < Data.length; x++) {
          Data[x].batch = Data[x].batch.batch;
          Data[x].date = moment(Data[x].purchase.date).format('DD-MM-YYYY');
          Data[x].quantity = Data[x].quantity;
          Data[x].total_amount = Data[x].purchase.total_amount;
          Data[x].discount_amount = Data[x].purchase.discount_amount;
          Data[x].sub_total_amount = Data[x].purchase.sub_total_amount;
          Data[x].purchase_from = Data[x].purchase.purchase_from;
          Data[x].warehouse = Data[x].purchase.wareHouse.name;
        }
        var rows = Data;
        var doc = jsPDF({
          orientation: 'landscape',
        });
        doc.setFontSize(13);
        // doc.setFontType("bold");
        doc.setTextColor(26, 26, 26);
        doc.setFont('helvetica', 'normal');
        doc.text('Purchase Report Product Management', 15, 5);

        doc.setFontSize(9);
        doc.text(
          246,
          5,
          `Generated Date and Time  -  ${moment(today).format(
            'DD-MM-YYYY HH:MM:SS',
          )}`,
          'center',
        );

        doc.setFontSize(9);

        // this.filterDatas.productquery
        //   ? doc.text(`Product  -    ${this.filterDatas.productquery}`, 15, 19)
        //   : null;
        // this.filterDatas.warehousequery
        //   ? doc.text(
        //       `Shop      -     ${this.filterDatas.warehousequery}`,15,26)
        //   : null;
        const conditions = [
          { key: 'productquery', label: 'Product' },
          { key: 'warehousequery', label: 'Warehouse' },
        ];

        // Function to get text based on filter data
        const getText = (key, label, value) => {
          return value ? `${label} - ${value}` : '';
        };

        // Iterate over conditions and build the text
        let height = conditions.reduce((acc, condition) => {
          const value = this.filterDatas[condition.key];
          const text = getText(condition.key, condition.label, value);

          if (text) {
            doc.text(text, 15, acc);
            return acc + 5; // Increment offset
          }

          return acc;
        }, 12); // Initial offset

        // Add Date Range if both start and end are available
        if (this.filterDatas.start && this.filterDatas.end) {
          const dateRangeText = `Date Range - ${this.filterDatas.start} - ${this.filterDatas.end}`;
          doc.text(dateRangeText, 15, height);
          height += 5; // Increment offset
        }

        // Add Total Amount, Discount Amount, and Paid Amount
        doc.text(211, 12, `Total Amount : `);
        doc.text(282, 12, this.total.toFixed(2), 'right');
        doc.text(211, 17, `Discount Amount :`);
        doc.text(282, 17, this.discount.toFixed(2), 'right');
        doc.text(211, 22, `Paid Amount : `);
        doc.text(282, 22, this.paid.toFixed(2), 'right');

        // Set a default height if no conditions matched
        height = height || 20;

        doc.autoTable(
          this.headers.map((h) => {
            return { title: h.text, dataKey: h.value };
          }),
          rows,
          {
            didParseCell: function (data) {
              if (data.column.dataKey === 'addsress') {
                data.cell.text = data.cell.raw.country;
              }
            },
            startY: height,
          },
        );
        const today = new DateTime();
        doc.save(`${moment(today).format('DD-MM-YYYY')}-Purchase Report.pdf`);
      };
      this.generateReport(printPdf);
    },

    //Product Details Export Excel
    async exceldownload() {
      const printExcel = () => {
        var data = document.getElementById('indextable5');
        const today = new DateTime();
        const headData = XLSX.utils.table_to_sheet(data);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(
          wb,
          headData,
          moment(today).format('DD-MM-YYYY'),
        );
        XLSX.writeFile(
          wb,
          `${moment(today).format('DD-MM-YYYY')}-Purchase Report.xlsx`,
        );
      };
      this.generateReport(printExcel);
    },
  },
};
</script>
